import { useEffect } from "react";
import { hasAcceptedCurrentLegalVersion } from "@akina/domain";
import type { TermsAndConditionsResponse } from "types/schemas";
import { useFetchLegalPage } from "./useFetchLegalPage";

export const useNavigateToTermsAndConditions = (params: {
  terms: TermsAndConditionsResponse | null | undefined;
  setTermsModalOpen: (open: boolean) => void;
  setPrivacyPolicyModalOpen: (open: boolean) => void;
  setTermsAndPrivacyPolicyModalOpen: (open: boolean) => void;
}) => {
  const { terms, setTermsModalOpen, setPrivacyPolicyModalOpen, setTermsAndPrivacyPolicyModalOpen } = params;
  const { data: termsAndConditionsLegalPage } = useFetchLegalPage("terms-and-conditions", "care");
  const { data: privacyPolicyLegalPage } = useFetchLegalPage("privacy-policy-and-data-transparency", "care");
  
  useEffect(() => {
    if (terms && privacyPolicyLegalPage && termsAndConditionsLegalPage) {
      const { privacyPolicyAccepted, termsAndConditionsAccepted } = hasAcceptedCurrentLegalVersion(
        termsAndConditionsLegalPage,
        privacyPolicyLegalPage,
        terms,
      );
      if (!privacyPolicyAccepted && !termsAndConditionsAccepted) return setTermsAndPrivacyPolicyModalOpen(true);

      if (!termsAndConditionsAccepted) return setTermsModalOpen(true);
      if (!privacyPolicyAccepted) return setPrivacyPolicyModalOpen(true);

      if (privacyPolicyAccepted && termsAndConditionsAccepted) {
        setTermsAndPrivacyPolicyModalOpen(false);
        setTermsModalOpen(false);
        setPrivacyPolicyModalOpen(false);
      }
    }
  }, [termsAndConditionsLegalPage, privacyPolicyLegalPage, terms, setTermsModalOpen, setPrivacyPolicyModalOpen, setTermsAndPrivacyPolicyModalOpen]);
};
